
import { computed, defineComponent } from 'vue';

export default defineComponent({
  name: 'ServiceTypeBadge',
  props: {
    service: {
      type: Object,
      required: true,
    },
    floating: {
      type: Boolean,
      default: true,
    },
    contentClass: {
      type: String,
      default: '',
    },
  },
  setup(props, ctx) {
    /**
     * Необходимо ли отображать badge
     *
     * @param service
     * @returns
     */
    const haveBadge = <
      T extends {
        isInternal: boolean;
        isOutside: boolean;
        isInformation: boolean;
      }
    >(
      service: T
    ): boolean => service.isInternal || service.isOutside || service.isInformation;

    const internalTitle = 'Внутреняя';

    const internalTooltip =
      // eslint-disable-next-line max-len
      'Услуга оказывается только в административной части системы и не доступна пользователям для получения на портальной части системы';

    const outsideTitle = 'Внешняя';

    const outsideTooltip =
      // eslint-disable-next-line max-len
      'Услуга оказывается во внешней системе и после нажатия "Перейти к услуге" вы будете перенаправлены';

    const informationTitle = 'Информационная';

    const informationTooltip = 'Предоставляется только описание по услуге';

    const badgeOptions = computed(() => [
      {
        title: internalTitle,
        tooltip: internalTooltip,
        show: props.service.isInternal,
      },
      {
        title: outsideTitle,
        tooltip: outsideTooltip,
        show: props.service.isOutside,
      },
      {
        title: informationTitle,
        tooltip: informationTooltip,
        show: props.service.isInformation,
      },
    ]);

    return {
      haveBadge,
      badgeOptions,
    };
  },
});
